<template>
  <div>
    <InputText
      id="email"
      v-model="inputValue"
      class="w-full"
      :invalid="isErrored"
      :disabled="isDisabled"
      :placeholder="inputPlaceholder"
    />
  </div>
</template>

<script lang="ts" setup>
const inputValue = defineModel<string | null>('inputValue', {
  required: true,
})
const isErrored = defineModel<boolean>('isErrored', {
  required: false,
})
const isDisabled = defineModel<boolean>('isDisabled', {
  required: false,
})
const inputPlaceholder = defineModel<string>('inputPlaceholder', {
  required: false,
})

const isValid = ref<boolean>(false)

const { validateEmail } = useUtils()

const validate = async (input: string, workSpaceId?: string) => {
  if (!input) {
    return isValid.value = false
  }

  const res = await validateEmail(input, workSpaceId)
  return isValid.value = res
}

defineExpose({ validate, isValid })
</script>
